var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 318.364,
    height: 59.533,
    viewBox: "0 0 318.364 59.533",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.302
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_engagedigital",
    transform: "translate(-116.983 -881.578)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8568",
    "data-name": "Group 8568",
    transform: "translate(10 249.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9524",
    "data-name": "Path 9524",
    d: "M198.647-690.7c4.843,0,7.852,3.611,7.852,8.683l-.029,12.409H202.23l.029-11.549c0-3.754-1.633-5.732-4.729-5.732-3.238,0-5.56,2.608-5.56,6.247l-.029,11.033H187.7l.029-20.634h2.952l.831,2.894A8.659,8.659,0,0,1,198.647-690.7Z",
    transform: "translate(-55.583 1353.192)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9525",
    "data-name": "Path 9525",
    d: "M289.364-690.114l-.029,17.94c0,6.591-3.926,10.6-10.346,10.575-5.3,0-9.056-2.751-10.088-7.279h4.241c.774,2.264,3.21,3.525,5.818,3.525a5.866,5.866,0,0,0,6.19-6.248v-.946a10.527,10.527,0,0,1-6.849,2.465,10.059,10.059,0,0,1-10.2-10.26,10.1,10.1,0,0,1,10.231-10.26,10.241,10.241,0,0,1,7.537,3.181l.688-2.665Zm-10.546,16.077a6.144,6.144,0,0,0,6.362-6.3,6.128,6.128,0,0,0-6.333-6.333,6.168,6.168,0,0,0-6.391,6.3,6.168,6.168,0,0,0,6.362,6.333Z",
    transform: "translate(-112.942 1353.122)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9526",
    "data-name": "Path 9526",
    d: "M380.224-690.089l-.029,20.634h-3.439l-.4-2.522a10.382,10.382,0,0,1-7.508,3.009A10.541,10.541,0,0,1,358.1-679.8a10.541,10.541,0,0,1,10.775-10.8,10.317,10.317,0,0,1,7.566,3.1l.487-2.579Zm-4.27,10.317a6.583,6.583,0,0,0-6.735-6.792,6.606,6.606,0,0,0-6.792,6.763,6.623,6.623,0,0,0,6.763,6.792A6.583,6.583,0,0,0,375.954-679.772Z",
    transform: "translate(-177.15 1353.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9527",
    "data-name": "Path 9527",
    d: "M472.335-689.914l-.029,17.94c0,6.591-3.926,10.6-10.346,10.575-5.3,0-9.056-2.751-10.088-7.279h4.241c.8,2.264,3.21,3.525,5.846,3.525a5.866,5.866,0,0,0,6.19-6.247v-.946a10.377,10.377,0,0,1-6.849,2.465,10.059,10.059,0,0,1-10.2-10.26,10.1,10.1,0,0,1,10.231-10.26,10.242,10.242,0,0,1,7.537,3.181l.688-2.665Zm-10.546,16.077a6.144,6.144,0,0,0,6.362-6.3,6.128,6.128,0,0,0-6.333-6.333,6.184,6.184,0,0,0-6.391,6.3,6.151,6.151,0,0,0,6.362,6.333Z",
    transform: "translate(-243.497 1352.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9528",
    "data-name": "Path 9528",
    d: "M562.178-679.51a11.081,11.081,0,0,1-.086,1.376l-16.794-.029a6.035,6.035,0,0,0,6.333,5.416,6.2,6.2,0,0,0,5.56-3.009h4.471a10.494,10.494,0,0,1-10.059,6.993A10.492,10.492,0,0,1,541-679.6a10.491,10.491,0,0,1,10.632-10.8c6.333,0,10.546,4.9,10.546,10.89Zm-10.546-7.05a6.081,6.081,0,0,0-6.219,4.958l12.495.029a6.171,6.171,0,0,0-6.276-4.987Z",
    transform: "translate(-307.634 1352.978)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9540",
    "data-name": "Path 9540",
    d: "M650.552-713.4v27.6h-4.041l-.659-1.691a9.751,9.751,0,0,1-6.362,2.293,10.44,10.44,0,0,1-10.69-10.747,10.416,10.416,0,0,1,10.69-10.718,9.783,9.783,0,0,1,5.588,1.691V-713.4Zm-5.072,17.453a5.4,5.4,0,0,0-5.531-5.56,5.4,5.4,0,0,0-5.531,5.56,5.4,5.4,0,0,0,5.531,5.56,5.417,5.417,0,0,0,5.531-5.56Z",
    transform: "translate(-370.272 1369.387)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9541",
    "data-name": "Path 9541",
    d: "M723.2-707.3h5.5v20.29h-5.5Zm0-7.8h5.474v5.1H723.2Z",
    transform: "translate(-437.619 1370.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9542",
    "data-name": "Path 9542",
    d: "M777.493-689.257v17.94c0,6.333-3.955,10.26-10.374,10.26-5.5,0-9.429-2.808-10.374-7.451h5.474c.63,1.834,2.751,2.751,4.815,2.751,2.78,0,5.1-1.805,5.1-4.757v-.745a9.787,9.787,0,0,1-5.818,1.805A10.013,10.013,0,0,1,756.2-679.6a10.044,10.044,0,0,1,10.116-10.2,9.881,9.881,0,0,1,6.763,2.579l.888-2.006h3.525Zm-5.388,9.629a5.043,5.043,0,0,0-5.187-5.244,5.027,5.027,0,0,0-5.187,5.244,5.027,5.027,0,0,0,5.187,5.245A5.027,5.027,0,0,0,772.105-679.628Z",
    transform: "translate(-461.161 1352.552)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9543",
    "data-name": "Path 9543",
    d: "M848.9-707.3h5.5v20.29h-5.5Zm0-7.8h5.474v5.1h-5.445Z",
    transform: "translate(-527.295 1370.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9544",
    "data-name": "Path 9544",
    d: "M893.188-685.537v4.9h-3.9c-4.471,0-7.222-2.751-7.222-7.251v-8.626H878.4v-1.175l8.024-8.511h1.06v5.3H893.1v4.413h-5.531v7.91a2.829,2.829,0,0,0,3.124,3.1Z",
    transform: "translate(-548.341 1364.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9545",
    "data-name": "Path 9545",
    d: "M959.909-689.357v20.29h-4.3l-.459-1.806a9.951,9.951,0,0,1-6.591,2.407A10.433,10.433,0,0,1,937.9-679.212a10.4,10.4,0,0,1,10.661-10.69,9.86,9.86,0,0,1,6.677,2.493l.6-1.92Zm-5.416,10.145a5.4,5.4,0,0,0-5.531-5.56,5.4,5.4,0,0,0-5.531,5.56,5.4,5.4,0,0,0,5.531,5.56,5.384,5.384,0,0,0,5.531-5.56Z",
    transform: "translate(-590.789 1352.623)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9546",
    "data-name": "Path 9546",
    d: "M1033.1-713.4h5.5v27.6h-5.5Z",
    transform: "translate(-658.707 1369.387)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9547",
    "data-name": "Path 9547",
    d: "M1066.7-637.5h5.818v5.875H1066.7Z",
    transform: "translate(-682.677 1315.238)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9548",
    "data-name": "Path 9548",
    d: "M1118.51-689.357v20.29h-4.3l-.458-1.806a9.951,9.951,0,0,1-6.591,2.407,10.433,10.433,0,0,1-10.661-10.747,10.4,10.4,0,0,1,10.661-10.69,9.86,9.86,0,0,1,6.677,2.493l.573-1.92Zm-5.388,10.145a5.4,5.4,0,0,0-5.531-5.56,5.4,5.4,0,0,0-5.531,5.56,5.4,5.4,0,0,0,5.531,5.56A5.4,5.4,0,0,0,1113.122-679.212Z",
    transform: "translate(-703.937 1352.623)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9549",
    "data-name": "Path 9549",
    d: "M1191.7-707.3h5.5v20.29h-5.5Zm0-7.8h5.474v5.1H1191.7Z",
    transform: "translate(-771.855 1370.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9550",
    "data-name": "Path 9550",
    d: "M562.178-679.51a11.081,11.081,0,0,1-.086,1.376l-16.794-.029a6.035,6.035,0,0,0,6.333,5.416,6.2,6.2,0,0,0,5.56-3.009h4.471a10.494,10.494,0,0,1-10.059,6.993A10.492,10.492,0,0,1,541-679.6a10.491,10.491,0,0,1,10.632-10.8c6.333,0,10.546,4.9,10.546,10.89Zm-10.546-7.05a6.081,6.081,0,0,0-6.219,4.958l12.495.029a6.171,6.171,0,0,0-6.276-4.987Z",
    transform: "translate(-434.017 1352.978)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "radisys_logo_white",
    transform: "translate(18.714 833.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M110.991,48.34c2.6,0,3.892,2.2,2.6,3.663H101.981v11.1L98.27,66.643V48.34h12.721",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M164.673,52l-5.193,5.127,10.388,10.255h5.2l-10.39-10.255,2.59-2.537a3.663,3.663,0,0,0-2.59-6.254h-2.6C164.673,48.34,165.968,50.538,164.673,52Z",
    transform: "translate(-51.086 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M98.27,123.928l7.289-6.958,2.466,2.435-6.044,5.769H98.27Z",
    transform: "translate(0 -57.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M258.55,92.88c0-1.762,1.065-3.179,3.51-3.179,0,0,4.287.023,4.287,0,0,0,.023-1.014,0-1.036,0-1.312-.68-1.612-1.786-1.612-1.323,0-4.1.157-5.6.263V85.633a19.07,19.07,0,0,1,5.91-.754c2.453-.016,4.236.92,4.236,3.706v8.486h-2.15l-.61-1.363a8.368,8.368,0,0,1-4.371,1.5c-2.18-.039-3.425-1.421-3.425-3.108Zm4.026,2.107a11.458,11.458,0,0,0,3.771-1.008V91.41l-3.87.274a1.168,1.168,0,0,0-1.158,1.308v.783C261.312,94.8,261.891,94.987,262.576,94.987Z",
    transform: "translate(-133.819 -30.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M345.863,55.6a11.866,11.866,0,0,1,4.135.868V49.74h2.747V68.43h-2.2l-.551-1.323a7.976,7.976,0,0,1-4.135,1.464c-3.237,0-4.135-2.841-4.135-6.406C341.72,58.425,342.325,55.6,345.863,55.6Zm.551,10.524a7.544,7.544,0,0,0,3.576-.895v-6.8a10.867,10.867,0,0,0-3.576-.528c-1.224,0-1.93.719-1.93,4.184,0,2.923.681,4.036,1.93,4.036Z",
    transform: "translate(-203.259 -1.168)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M428.839,60.635a.534.534,0,0,1,.572-.6h2.024a.531.531,0,0,1,.539.6v1.819a.5.5,0,0,1-.539.547h-2.024a.533.533,0,0,1-.572-.547ZM429,64.387h2.762V77.033H429Z",
    transform: "translate(-275.987 -9.765)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M465.91,88.738c0-1.846.827-3.128,3.286-3.128a31.694,31.694,0,0,1,6.558.518v1.733h-5.908c-1.1,0-1.174.366-1.174,1.006v.715c0,.938.5.96,1.174.96h3.28c2.289,0,3.263,1.3,3.263,3.023v1.182c0,2.456-1.573,3.041-3.1,3.041-1.952,0-5.971-.188-6.859-.569V95.525h6.174a.89.89,0,0,0,1.017-.924v-.757c0-.607-.2-.946-1.017-.946h-3.245c-2.24,0-3.454-.8-3.454-3.116Z",
    transform: "translate(-306.946 -31.106)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M545.319,86.32l2.506,9.224a1.169,1.169,0,0,0,1.381.93l2.927-10.154h2.928l-4.815,16.652-1.753,2.43h-1.912l1.947-6.431c-1.3,0-2.755-.581-3.434-3l-2.7-9.643Z",
    transform: "translate(-370.827 -32.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M632.37,88.738c0-1.846.827-3.128,3.286-3.128a31.7,31.7,0,0,1,6.558.518v1.733h-5.908c-1.1,0-1.174.366-1.174,1.006v.715c0,.938.5.96,1.174.96h3.28c2.289,0,3.263,1.3,3.263,3.023v1.182c0,2.456-1.573,3.041-3.1,3.041-1.952,0-5.971-.188-6.859-.569V95.525h6.176a.889.889,0,0,0,1.016-.924v-.757c0-.607-.2-.946-1.016-.946h-3.247c-2.239,0-3.453-.8-3.453-3.116Z",
    transform: "translate(-445.925 -31.106)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c29f98633a6f4d93a0cd802c4536e285.svg";
export { ForwardRef as ReactComponent };